<script>
  import Analytics from "$lib/assets/imgs/Website Analytics@2x.webp";
</script>

<section class="mt-28 px-4">
  <div
    class="container mx-auto lg:h-[555px] w-full overflow-hidden bg-white rounded-2xl shadow-sm flex flex-wrap lg:flex-nowrap"
  >
    <!-- Text Side -->
    <div class="lg:w-1/2 p-8 md:p-16 lg:p-20 flex flex-col justify-center">
      <div
        class="inline-flex items-center gap-2 bg-purple-100 text-purple-700 text-sm font-semibold px-4 py-1.5 rounded-full w-fit mb-6"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          />
        </svg>
        Website Analytics
      </div>
      <h2 class="text-2xl lg:text-4xl font-bold text-gray-900 leading-tight">
        Improve customer
        <span class="text-green-500">acquisition</span>
      </h2>
      <p class="text-gray-600 text-lg mt-4 leading-relaxed max-w-md">
        Customers do research online first. Uzakitu makes it easier for them to
        find your products and helps you understand their behavior.
      </p>
      <div class="mt-8 grid grid-cols-2 gap-4">
        <div class="bg-gray-50 rounded-xl p-4 text-center">
          <p class="text-2xl font-bold text-green-500">2x</p>
          <p class="text-sm text-gray-500 mt-1">More visibility</p>
        </div>
        <div class="bg-gray-50 rounded-xl p-4 text-center">
          <p class="text-2xl font-bold text-green-500">24/7</p>
          <p class="text-sm text-gray-500 mt-1">Online presence</p>
        </div>
      </div>
    </div>
    <!-- Image Side -->
    <div
      class="lg:w-1/2 p-8 lg:p-14 bg-gradient-to-br from-purple-50 to-green-50 flex items-center justify-center"
    >
      <img
        class="object-contain max-h-full rounded-lg shadow-lg"
        src={Analytics}
        alt="Website Analytics"
        loading="lazy"
      />
    </div>
  </div>
</section>
